import React, { useState, useEffect } from "react";

export default function About() {
  const [photoIndex, setPhotoIndex] = useState(0);
  const photos = [
    "https://1.bp.blogspot.com/-fMwEe9KYLDs/V5GW-gep0ZI/AAAAAAAAATM/k7DCfEtc2DsTMpPGDxoOe2uytO0p-52KQCLcB/s1600/Pranamasana4.jpg",
    "https://th.bing.com/th/id/R.890bc5f0e7760ea50dae260ca0481904?rik=u6gzLEd06HdQvA&riu=http%3a%2f%2f1.bp.blogspot.com%2f-d6uYQaVuKTg%2fVe5q_6qISlI%2fAAAAAAAAAPs%2fYsJSsaDwLtg%2fs1600%2fSN-Raised-arms-pose-Hasta-Utthanasana10.jpg&ehk=DdbMWssqiLBvzHc5zcS4WrMY%2fyEBmOCMZkktDuzgpSE%3d&risl=&pid=ImgRaw&r=0",
    "https://th.bing.com/th/id/OIP._YCWlG6zhIxIUXiAHKCiagHaFj?rs=1&pid=ImgDetMain",
    "https://cdn.goconqr.com/uploads/flash_card/image_question/2879118/desktop_cac08101-3fa4-48f2-bb9a-3fab464c976c.jpg",
    "https://www.drsusanjamieson.com/wp-content/uploads/2013/01/Fotolia_47022376_XS.jpg",
    "https://th.bing.com/th/id/OIP.EGmysFuYbD7pLYVoED3rWAHaE5?rs=1&pid=ImgDetMain",
    "https://www.fitnessgymyoga.com/wp-content/uploads/2017/05/For-Gas-poses-to-relieve-gas-so-effective-youll-want-be.jpg",
    "https://i.pinimg.com/originals/cd/c6/a2/cdc6a2f0ab16f4fd62731e28ba2d869e.jpg",
    "https://th.bing.com/th/id/OIP._YCWlG6zhIxIUXiAHKCiagHaFj?rs=1&pid=ImgDetMain",
    "https://th.bing.com/th/id/R.890bc5f0e7760ea50dae260ca0481904?rik=u6gzLEd06HdQvA&riu=http%3a%2f%2f1.bp.blogspot.com%2f-d6uYQaVuKTg%2fVe5q_6qISlI%2fAAAAAAAAAPs%2fYsJSsaDwLtg%2fs1600%2fSN-Raised-arms-pose-Hasta-Utthanasana10.jpg&ehk=DdbMWssqiLBvzHc5zcS4WrMY%2fyEBmOCMZkktDuzgpSE%3d&risl=&pid=ImgRaw&r=0",
  ];

  useEffect(() => {
    const intervalId = setInterval(() => {
      setPhotoIndex((prevIndex) => (prevIndex + 1) % photos.length);
    }, 2000);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <div
      id="about"
      className="flex flex-col gap-x-10 md:flex-row justify-center items-center px-4 section-sm lg:section-md"
    >
      <div               data-aos="fade-right"
              data-aos-delay="900" className="md:w-1/3 flex items-center justify-center text-center">
        {/* Photo display that changes every 2 seconds */}
        <div>
          <img
            src={photos[photoIndex]}
            alt="About Me"
            className=" w-[400] h-[400] md:max-w-[340px] md:h-auto"
          />
        </div>
      </div>
      <div className="md:w-1/2 p-4 md:px-14 mt-4 md:mt-0">
        {/* Heading about me */}
        <h2               data-aos="fade-left"
              data-aos-delay="500" className="text-3xl font-bold mb-6">About Me</h2>

        {/* Paragraph */}
        <p data-aos="fade-left"
              data-aos-delay="600"  className="text-md mb-4">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Again all
          this is just dummy text which will be replaced by some sensible and
          meaningful text. These text are used by the developers to build
          website frontend to check how it looks after content is filled. Lorem
          ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod
          tempor incididunt ut labore et dolore magna aliqua.
        </p>

        {/* Small card with mobile number */}
        <div data-aos="fade-left"
              data-aos-delay="700" className="bg-green px-4 py-2 rounded-md mt-5">
          <p className="text-lg text-white font-semibold mb-2">
            Contact Information
          </p>
          <p className="text-white font-semibold">Mobile: +123 456 7890</p>
        </div>
      </div>
    </div>
  );
}
